/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_OwnershipInputs */

const cs_filter_ownership = /** @type {(inputs: Filter_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastnictví`)
};

const en_filter_ownership = /** @type {(inputs: Filter_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ownership`)
};

/**
* | output |
* | --- |
* | "Ownership" |
*
* @param {Filter_OwnershipInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_ownership = /** @type {((inputs?: Filter_OwnershipInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_OwnershipInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_ownership(inputs)
	return cs_filter_ownership(inputs)
});